import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConfirmPass } from './formErrors';
import './style.css'
import { sendForgotPasswordEmail } from '../../action/authAction'
// import NAVBARAUTH from './navBar'
import { browserHistory } from 'react-router';


class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailChage: '',
            confirmPass: { emailChage: '' },
            emailChageValid: false,
            changePass: false,
        }
    }
    ForgetHandle = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateChagePass(name, value) });
    }

    validateChagePass(fieldName, value) {
        let fieldValidationErrors = this.state.confirmPass;
        let emailChageValid = this.state.emailChageValid;


        switch (fieldName) {
            case 'emailChage':
                emailChageValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.Email = emailChageValid ? '' : ' is invalid (example@gmail.com)';
                break;
            default:
                break;
        }
        this.setState({
            confirmPass: fieldValidationErrors,
            emailChageValid: emailChageValid,
        }, this.validateFormNewPass);
    }
    validateFormNewPass() {
        this.setState({ changePass: this.state.emailChageValid });
    }
    errorClass(error) {
        return (error.length === 0 ? '' : 'has-error');
    }
    SubmitChagnePassword() {
        let emailChage = this.state.emailChage;

        let ForgetPasswords = {
            email: emailChage,
        }
        // console.log('User Login', ForgetPasswords);
        this.props.sendForgotPasswordEmail(ForgetPasswords);
    }
    Cancel(){
        browserHistory.push('/home');
    }
    render() {
        const {
            sent,
        } = this.props;
        return (
            <div>
                {/* <NAVBARAUTH /> */}
                <div className='col-md-4 col-md-offset-4 col-xs-10 col-xs-offset-1 login'>
                    <div className="page-header text-center">
                        <p style={{ textShadow: '0px 2px 3px gray', fontSize: '3em', fontWeight: 'bold', color: '#41c4dd' }}>Change Password</p>
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Enter your email, You have.</label>
                        <input
                            name="emailChage"
                            className="form-control"
                            placeholder="Enter email"
                            required
                            value={this.state.emailChage}
                            onChange={this.ForgetHandle}
                            style={{height: 45, fontSize: 18}}
                        />
                    </div>
                    <div style={{ marginTop: 10, fontSize: 16, color: 'red' }}>
                        <ConfirmPass confirmPass={this.state.confirmPass} />
                    </div>
                    <div>
                        {(sent) ? (
                            <div style={{ marginTop: 10, fontSize: 16, color: 'blue', textAlign: 'center' }}>
                                {sent}
                            </div>
                        ) : (
                                <span></span>
                            )}
                    </div>
                    <div className="btn-group btn-group-lg btn-group-justified">
                        <a onClick={this.SubmitChagnePassword.bind(this)} className="btn btn-info" disabled={!this.state.changePass}>Send Request</a>
                        <a onClick={this.Cancel.bind(this)} className="btn btn-info">Cancel</a>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        sent: state.authReducers.sentEmail
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        sendForgotPasswordEmail: (ForgetPasswords) => {
            dispatch(sendForgotPasswordEmail(ForgetPasswords));
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);
// export default ForgetPassword;


// WEBPACK FOOTER //
// ./src/component/auth/forget.jsx